import { render, staticRenderFns } from "./FairRoll.vue?vue&type=template&id=fdb40a46&scoped=true"
import script from "./FairRoll.vue?vue&type=script&lang=js"
export * from "./FairRoll.vue?vue&type=script&lang=js"
import style0 from "./FairRoll.vue?vue&type=style&index=0&id=fdb40a46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb40a46",
  null
  
)

export default component.exports